/* eslint-disable @typescript-eslint/no-shadow */
import { useMemo } from 'react';
import * as React from 'react';

import {
  BetType,
  EntryRacer,
  Race,
  ReleaseStatus,
} from '@/lib/apollo/types/gen/graphql';
import {
  BetMethod,
  FirstThreeRacerData,
  RacerNumber,
  WheelAxisList,
} from '@/modelTypes';

import BoxSheet from './BoxSheet';
import FormationSheet from './FormationSheet';
import WheelSheet from './WheelSheet';

interface BetSheetProps {
  race: Race;
  betType: BetType;
  betMethod: BetMethod;
  wheelAxisList: WheelAxisList;
  firstThreeRacerData: FirstThreeRacerData;
  setFirstThreeRacerData: React.Dispatch<
    React.SetStateAction<FirstThreeRacerData>
  >;
}

const BetSheet: React.FC<BetSheetProps> = ({
  race,
  betType,
  betMethod,
  wheelAxisList,
  firstThreeRacerData,
  setFirstThreeRacerData,
}) => {
  const makeRacerNumbers = (entryRacers: EntryRacer[]): RacerNumber[] =>
    useMemo(
      () =>
        entryRacers.map(er => {
          return {
            bicycleNum: er.bicycleNum,
            bracketNum: er.bracketNum,
          };
        }),
      [entryRacers],
    );

  const isDisabledBicycleNumber = (bicycleNum: number) =>
    race.entryRacers.filter(er => er.bicycleNum === bicycleNum)[0]
      .releaseStatus !== ReleaseStatus.Released;

  return (
    <>
      {betMethod === BetMethod.Formation && (
        <FormationSheet
          bicycleCount={race.bicycleCount}
          racerNumbers={makeRacerNumbers(race.entryRacers)}
          firstThreeRacerList={firstThreeRacerData[BetMethod.Formation]}
          setFirstThreeRacerData={setFirstThreeRacerData}
          isDisabledBicycleNumber={isDisabledBicycleNumber}
        />
      )}
      {betMethod === BetMethod.Box && (
        <BoxSheet
          bicycleCount={race.bicycleCount}
          racerNumbers={makeRacerNumbers(race.entryRacers)}
          firstThreeRacerList={firstThreeRacerData[BetMethod.Box]}
          setFirstThreeRacerData={setFirstThreeRacerData}
          isDisabledBicycleNumber={isDisabledBicycleNumber}
        />
      )}
      {betMethod === BetMethod.Wheel && (
        <WheelSheet
          betType={betType}
          racerNumbers={makeRacerNumbers(race.entryRacers)}
          wheelAxis={wheelAxisList[betType]}
          firstThreeRacerList={firstThreeRacerData[BetMethod.Wheel]}
          setFirstThreeRacerData={setFirstThreeRacerData}
          isDisabledBicycleNumber={isDisabledBicycleNumber}
        />
      )}
    </>
  );
};

export default BetSheet;
